<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-container class="py-0">
                    <v-row>
                        <v-col sm="auto">
                            <v-checkbox
                                v-model="product.signaturesDivision"
                                class="mt-2"
                                label="Podział wnętrz na składki"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col sm="auto">
                            <v-checkbox
                                v-model="product.isDieCutterRequired"
                                label="Wymaga wykrojnika"
                                hide-details
                                class="mt-1"
                                @change="dieCutterChange"
                            />
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="product.acronym"
                                label="Prefiks wykrojnika"
                                outlined
                                dense
                                hide-details
                                :disabled="!product.isDieCutterRequired"
                                @input="changeAcronym"
                            />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="product.dieCuterProductPropertyId"
                                label="Cecha sklepowa dla wykrojnika"
                                :items="productProperties"
                                outlined
                                dense
                                item-value="id"
                                item-text="name"
                                no-data-text="Nie znaleziono cech sklepowych"
                                :disabled="!product.isDieCutterRequired"
                                :error-messages="dieCuterProductPropertyIdErrors"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
        <v-btn
            color="success"
            medium
            data-sentry-label="Zapisz"
            :disabled="!hasProductChanges"
            @click="saveProduct"
        >
            Zapisz
        </v-btn>
    </v-container>
</template>
<script>
import { errorHandler } from '@/utils/errorHandler'
import parse from '@/mixins/parse'
import { requiredIf } from 'vuelidate/lib/validators'
import { isEqual } from 'lodash'

export default {
    name: 'ProductFeatures',
    mixins: [
        parse
    ],
    props: {
        productData: {
            type: Object,
            default: () => {}
        },
        productProperties: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            product: {
                name: null,
                productTypeComponent: [],
                isDieCutterRequired: false,
                acronym: null,
                dieCuterProductPropertyId: null,
                signaturesDivision: false
            },
            actionLoading: {
                saveProduct: false
            }
        }
    },
    computed: {
        hasProductChanges() {
            const hasProductChanges = !isEqual(this.product, this.productData)

            this.$emit('on-product-change', hasProductChanges)

            return hasProductChanges
        },
        dieCuterProductPropertyIdErrors() {
            let errors = []

            if (!this.$v.product.dieCuterProductPropertyId.$dirty) return errors
            if (!this.$v.product.dieCuterProductPropertyId.required)
                errors.push('Cecha sklepowa jest wymagana.')

            return errors
        },
    },
    validations: {
        product: {
            dieCuterProductPropertyId: {
                required: requiredIf(function() {
                    return this.product.isDieCutterRequired
                })
            },
        }
    },
    watch: {
        productData: {
            handler: function(newValue) {
                this.product = JSON.parse(JSON.stringify(newValue))
            },
            deep: true
        }
    },
    mounted() {
        this.product = JSON.parse(JSON.stringify(this.productData))
    },
    methods: {
        saveProduct() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }
            this.actionLoading.saveProduct = true
            this.$store.dispatch('configurations/saveProduct', {
                id: this.product.id,
                payload: this.product
            })
                .then(response => {
                    this.$emit('update-product-data', response.data)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.saveProduct = false
                })
        },
        dieCutterChange() {
            if (!this.product.isDieCutterRequired) {
                this.product.acronym = null
                this.product.dieCuterProductPropertyId = null
            }
        },
        changeAcronym(value) {
            this.product.acronym = this.parseEmptyStringToNull(value)
        },
    }
}
</script>